import { createContext } from 'react';

import { CompanyAuthContextValue } from './company-auth-context.type';

export const defaultCompanyAuthContextValue: CompanyAuthContextValue = {
  isFinished: false,
  permissions: [],
  channels: [],
  role: undefined,
  teams: [],
  setCompanyAuthId: () => {},
  setCompanyClubId: () => {},
};

export const CompanyAuthContext = createContext<CompanyAuthContextValue>(defaultCompanyAuthContextValue);
